import Backbone from "backbone";
import _ from "underscore";
import {sort} from "utils";
import template from "./template.html";

let UnitListView = Backbone.View.extend({
    template,
    className: "fp-panel",
    id: "fp_view_units",
    initialize: function(options) {
        this.floorPlan = options.floorPlan;
        this.unit = options.unit;
        this.sort = {
            key: options.unitSortBy || "available_date",
            dsc: false
        };
        this.options = {
            "useListDisclaimer": options.useListDisclaimer,
            "listDisclaimer": options.listDisclaimer || "* Pricing based on lease term selected when reserving this home.",

            "noAvailableUnitsText": options.noAvailableUnitsText || "Contact us for more information on available apartments.",
            "contactLinkURL": options.contactLinkURL || "/contact_us/",
            "availabilityFirstText": options.availabilityFirstText || "You may view the floor plan details or apply to the wait-list ",
            "availabilityLinkText": options.availabilityLinkText || "here",
            "availabilitySecondText": options.availabilitySecondText || ".",

            "useKnockContact": options.useKnockContact || false,
            "knockContactFirstText": options.knockContactFirstText || "If you have any questions please click ",
            "knockContactLinkText": options.knockContactLinkText || "here",
            "knockContactSecondText": options.knockContactSecondText || ".",
            "apartmentType": options.apartmentType || "Apartment"
        };
    },
    attributes: {
        role: "tabpanel"
    },
    events: {
        "click .unit-details": "selectUnit",
        "click .app-back-button": "backButton",
        "click .header > [data-sort]": "sortUnits"
    },
    render: function() {
        let units = [];
        let active = this.unit;
        let fp = this.floorPlan;
        let hideUnitNumbers = false;
        let hideUnitAvailability = false;

        if (fp) {
            units = fp.getUnits();
            hideUnitNumbers = fp.getHideUnitNumbers();
            hideUnitAvailability = fp.getHideUnitAvailability();
        }
        let options = this.options;

        let sortFunc = sort.natural;
        let sortClass = `icon-sort-alpha-${this.sort.dsc ? "desc" : "asc"}`;
        if (this.sort.key == "available_date") {
            sortFunc = sort.numeric;
            sortClass = `icon-sort-amount-${this.sort.dsc ? "desc" : "asc"}`;
        }
        units.sort((a, b) => sort.model(sortFunc, this.sort.key, a, b, this.sort.dsc));

        let noUnits = hideUnitAvailability || (fp && !units.length);
        let context = {
            active,
            units,
            sortClass,
            sort: this.sort,
            availabilityLink: fp.get("availability_link"),
            hideUnitNumbers,
            noUnits,
            ...options
        };

        this.$el.toggleClass("no-units", noUnits);
        this.$el.html(this.template(context));
        this.delegateEvents();

        return this;
    },
    selectUnit: function(e) {
        e.preventDefault();
        let elem = e.currentTarget;
        let id = parseInt(elem.id.substr(4), 10);
        this.collection.setActiveUnit(id);

        this.trigger("tab", "#fp_view_detailed");
    },
    backButton: function(e) {
        e.preventDefault();
        this.trigger("tab", "#fp_view_start");
    },
    sortUnits: function(e) {
        let prop = e.currentTarget.getAttribute("data-sort");
        if (prop === this.sort.key) {
            this.sort.dsc = !this.sort.dsc;
        } else {
            this.sort.key = prop;
            this.sort.dsc = false;
        }
        this.render();
    }
});

export {UnitListView};
